import './Tienda.css';
import brushStroke from '../assets/images/brush-stroke.webp';
import MerchCard from '../components/MerchCard';

import image1 from '../assets/merch/1.webp';
import image2 from '../assets/merch/2.webp';
import image3 from '../assets/merch/3.webp';
import image4 from '../assets/merch/4.webp';

const productos = [
  { id: 1, title: 'Camiseta Básica MBZ',       image: image1, price: 25 },
  { id: 2, title: 'Sudadera Con Capucha MBZ',  image: image2, price: 40 },
  { id: 3, title: 'Pantalonera Deportiva MBZ', image: image3, price: 30 },
  { id: 4, title: 'Shaker Oficial MBZ',        image: image4, price: 10 },
];

export default function Tienda() {
  return (
    <div className="tienda-page">
      <h1 className="tienda-title">
        <div className="title-container">
          <img src={brushStroke} alt="" className="brush-behind" />
          <span className="title-text">Tienda MBZ</span>
        </div>
      </h1>

      <div className="tienda-grid">
        {productos.map(item => (
          <MerchCard
            key={item.id}
            title={item.title}
            image={item.image}
            price={item.price}
          />
        ))}
      </div>
    </div>
  );
}
